import { Pipe, PipeTransform } from '@angular/core';
import { LangDataService } from '../core/lang-data.service';

@Pipe({name: 'translate'})
export class TranslatePipe implements PipeTransform {
    constructor(private lang: LangDataService) {}

    public transform(key: string, defaultString?: string): string {
        return this.lang.getString(key, defaultString);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/translate.pipe.ts